import React from "react";
import "./pages-head.component.scoped.scss";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { history } from "react-router-guard";
import { Box, Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const PagesHeadComponent: React.FunctionComponent<{
  title: string;
  subTitle: string;
  logo?: string;
  path?: string;
  loading?: boolean;
}> = ({ title, subTitle, logo, path, loading = false }) => {
  return (
    <Box className="py-4">
      <Box className="d-flex justify-content-between align-items-center mb-2">
        <Box className="content">
          {loading ? (
            <Skeleton variant="text" width={400} height={20} />
          ) : (
            <Box className="title">
              {path && (
                <span
                  onClick={() => history.push(path || "/")}
                  style={{ cursor: "pointer" }}
                >
                  <ChevronLeftIcon />
                </span>
              )}
              <Typography variant="h1" color="textPrimary">
                {title}
              </Typography>
            </Box>
          )}
          {loading ? (
            <Skeleton variant="text" width={300} height={18} />
          ) : (
            <Typography variant="body1" color="textPrimary">
              {subTitle}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PagesHeadComponent;
